import React, { useEffect } from 'react'
import { all_routes } from '../router/all_routes'
import CollapseHeader from '../../core/common/collapse-header';
import { setPermissionsState, setUser } from '../../Features/authslice';
import { useUpsertUserProfileAsyncMutation } from '../../services/EndPointsApis';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const BlankPage = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate()
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);
  const token = params.get("access_token");

  const [createUserDetails, { data, isLoading, isSuccess, isError, error }] = useUpsertUserProfileAsyncMutation();
  
  useEffect(() => {
    if (token !== '') {
      createUserDetails({ token })
    }
    if (isSuccess) {
      dispatch(
        setUser({
          ...data?.result?.userAccountBasicInfo,
          // permissions:data?.result?.permissionsList,
          setUser: data?.result?.userAccountBasicInfo,
          token: data?.result?.token,
          expiresAt: data?.result?.expiresAt,
        }),
      );
      dispatch(
        setPermissionsState(data?.result?.permissionsList)
      );
      // setTimeout(() => {
      navigate('/dashboard')
      // }, 700);
    }
  }, [isSuccess])

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';
      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
      navigate('/')
    }
  }, [isError, error]);


  return (

    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="page-header">
              <div className="row align-items-center ">
                <div className="col-8">
                  <h3 className="page-title text-center">Authenticating....</h3>
                </div>
                <div className="col-4 text-sm-end">
                  <div className="title-head">
                    <div className="head-icons">

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



  )
}

export default BlankPage